import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { CouponsService } from 'src/app/shared/services/coupons.service';
declare var dataLayer;
@Component({
  selector: 'app-copon-added-dialog',
  templateUrl: './copon-added-dialog.component.html',
  styleUrls: ['./copon-added-dialog.component.scss']
})
export class CoponAddedDialogComponent implements OnInit {
  public coponApplied: boolean = false;
  public applycoupon: boolean;
  public removecoupon: boolean;
  userType: string;
  userId: any;
  tierType: any;
  constructor(
    private couponService: CouponsService,
    public dialogRef: MatDialogRef<CoponAddedDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private commonFunction: CommonFunctions
  ) {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    if (this.data['dataObj'] && this.data['dataObj'] === 'OK') {
      this.applycoupon = true;
    }
    if (this.data['dataObj'] && this.data['dataObj'] === 'Coupon Deleted successfully') {
      this.removecoupon = true;
    }
  }
  close() {
    this.dialogRef.close(this.data);
  }
  applyCopon() {
    this.dialogRef.close(this.data)
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}
